/* eslint-disable no-dupe-keys */
export default {
  charging_package_settlement_rule: {
    name: '充电包结算规则',
    // 属性（一般与对象内容匹配）
    prop: {
      name: '规则名称',
      electric_price: '结算电价',
      service_price: '结算服务价',
      transaction_fee_rate: '手续费率',
      sharing_fee_rate: 'ECMP渠道费率',
      charging_package_definitions: '充电包模板',
      internal_remark: '备注',
      last_settled_at: '最后结算时间',
      status: '状态',
      created_at: '创建时间',
      updated_at: '更新时间'
    },
    // Enum的属性
    statuses: {
      enabled: '可用的',
      disabled: '禁用的'
    },
    // 占位提示
    placeholder: {
      search_keyword: '查询规则名称',
      input_name: '请输入充电包结算规则名称',
      input_internal_remark: '内部说明'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息',
      ev_charging_station_settlements: '站结算记录',
      charging_package_settlements: '充电包结算记录'
    },
    // 标签标题
    list_tabs: {
      all: '全部',
      enabled: '可用的',
      disabled: '已禁用'
    },
    // 标题
    group_titles: {
      base_info: '基本信息'
    },
    tips: {
      charging_package_settlement: '定时每月3号统一结算'
    }
  }
}
